import { Link } from "react-router-dom";
import React from "react";
import { useEffect } from "react";

export default function Privacy (){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="privacy">
            
            <h1 style={{color:"black",textAlign:"center"}}>Informativa sulla privacy</h1> 
            <p>
            Questa informativa sulla privacy descrive come raccogliamo, utilizziamo e proteggiamo le informazioni che ci fornisci durante l'utilizzo del nostro sito web. Siamo impegnati a garantire la privacy e la sicurezza delle tue informazioni personali. Leggi attentamente questa informativa sulla privacy per comprendere le nostre pratiche riguardo alle tue informazioni.
            <br />
            <br />
            Raccolta delle informazioni:<br />
            Raccogliamo solo le informazioni che fornisci volontariamente attraverso il nostro sito web. Ciò può includere informazioni personali come il tuo nome, l'indirizzo email e qualsiasi altro dettaglio tu scelga di condividere con noi.
            <br />
            <br />
            Utilizzo delle informazioni:<br />
            Utilizziamo le informazioni che fornisci esclusivamente per fornirti i servizi che richiedi.
            <br />
            <br />
            Condivisione delle informazioni:<br />
            Non condividiamo, vendiamo, affittiamo o divulgamo le tue informazioni personali a terze parti, tranne in casi come requisiti legali: Possiamo divulgare le tue informazioni personali se richiesto dalla legge o in risposta a una valida richiesta legale.
            <br />
            <br />
            
            Sicurezza dei dati:<br />
            Adottiamo misure di sicurezza ragionevoli per proteggere le tue informazioni personali da accessi non autorizzati, utilizzo o divulgazione. Tuttavia, tieni presente che nessun metodo di trasmissione via internet o di conservazione elettronica è completamente sicuro, e non possiamo garantire la sicurezza assoluta delle tue informazioni.
            <br />
            <br />
            Privacy dei minori
            Il nostro sito web non è destinato all'utilizzo da parte di persone di età inferiore ai 13 anni. Non raccogliamo consapevolmente informazioni personali da minori. Se sei un genitore o un tutore e ritieni che tuo figlio ci abbia fornito informazioni personali, ti preghiamo di contattarci e provvederemo prontamente a cancellare tali informazioni dai nostri archivi.</p>
            <Link to="/">Ritorna alla Home</Link>
        </div>
    )
}